//
//  JockeyJS
//

;(function () {

    // 处理 ssr
    if (typeof window === 'undefined') {
        module.exports = {
            send: function(){},
            on: function(){},
            off: function(){}
        };
        return;
    }

    // Non-accessible variable to send to the app, to ensure events only
    // come from the desired host.
    var host = window.location.host;
    /**
     * @desc 公司所有app头信息集合 
     */
    var appArray = [ 'cheniu', 'dafengche', 'sccwk', 'buyerapp', 'souchedai', 'sccworkbench', 'spartner' , 'chemiaodai', 'brace' ];
    var ua = window.navigator.userAgent.toLowerCase();

    var app = (function() {
        for(var i = 0; i < appArray.length; i++){
            if (ua.indexOf(appArray[i]) !== -1) {
                return appArray[i];
            }
        }
        return '';
    })();
    
    // 通过 userAgent 判断当前环境是否支持 Jockey (dafengche && cheniu app support jockey)
    // spartner 第三方 app
    var hasJockeyNativeEnv = !!(ua.indexOf('jockey') !== -1 || app);

    var Dispatcher = {
        callbacks: {
            event: {},
            callback: {}
        },

        send: function(envelope, complete) {
            this.dispatchMessage("event", envelope, complete);
        },

        sendCallback: function(messageId, data) {
            var envelope = Jockey.createEnvelope(messageId, "callback", data);

            this.dispatchMessage("callback", envelope, function() {});
        },

        triggerCallback: function(id, data) {
            var dispatcher = this;

            // Alerts within JS callbacks will sometimes freeze the iOS app.
            // Let's wrap the callback in a timeout to prevent this.
            setTimeout(function() {
                dispatcher.callbacks.event[id](data);
            }, 0);
        },

        // `type` can either be "event" or "callback"
        dispatchMessage: function(type, envelope, complete) {
            // We send the message by navigating the browser to a special URL.
            // The iOS library will catch the navigation, prevent the UIWebView
            // from continuing, and use the data in the URL to execute code
            // within the iOS app.

            // for native call the callback multi times
            // var dispatcher = this;

            this.callbacks[type][envelope.id] = function(data) {
                complete(data);

                // for native call the callback multi times
                //delete dispatcher.callbacks[envelope.id];
            };
            setTimeout(function() {
                var src = "jockey://" + type + "/" + envelope.id + "?" + encodeURIComponent(JSON.stringify(envelope));
                var iframe = document.createElement("iframe");
                iframe.setAttribute("src", src);
                document.documentElement.appendChild(iframe);
                iframe.parentNode.removeChild(iframe);
                iframe = null;
            }.bind(this), 0);
        }
    };

    var Jockey = {
        listeners: {},

        dispatcher: null,

        messageCount: 0,

        on: function(type, fn) {
            if (!this.listeners.hasOwnProperty(type) || !this.listeners[type] instanceof Array) {
                this.listeners[type] = [];
            }

            this.listeners[type].push(fn);
        },

        off: function(type) {
            if (!this.listeners.hasOwnProperty(type) || !this.listeners[type] instanceof Array) {
                this.listeners[type] = [];
            }

            this.listeners[type] = [];
        },

        send: function(type, payload, complete) {
            if (payload instanceof Function) {
                complete = payload;
                payload = null;
            }

            payload = payload || {};
            complete = complete || function() {};

            var envelope = this.createEnvelope(this.messageCount, type, payload);

            this.dispatcher.send(envelope, complete);

            this.messageCount += 1;
        },

        // detect jockey native env is exist, added by qinghua
        hasJockeyNativeEnv: hasJockeyNativeEnv,

        app: app,

        preventCallback: function () {
            this.on = function () {};
            this.off = function () {};
        },

        // called by native application, use for detecting window.Jockey exist or not , added by geliang
        isHooked: function() {
            return true;
        },

        // Called by the native application when events are sent to JS from the app.
        // Will execute every function, FIFO order, that was attached to this event type.
        trigger: function(type, messageId, json) {
            var self = this;

            var listenerList = this.listeners[type] || [];

            var executedCount = 0;

            var complete = function(data) {
                executedCount += 1;

                if (executedCount >= listenerList.length) {
                    self.dispatcher.sendCallback(messageId, data);
                }
            };

            if (listenerList.length === 0) {
                return self.dispatcher.sendCallback(messageId, {
                    error: "NotFound"
                });
            }

            for (var index = 0; index < listenerList.length; index++) {
                var listener = listenerList[index];

                // If it's a "sync" listener, we'll call the complete() function
                // after it has finished. If it's async, we expect it to call complete().
                if (listener.length <= 1) {
                    listener(json);
                    complete();
                } else {
                    listener(json, complete);
                }
            }
        },

        // Called by the native application in response to an event sent to it.
        // This will trigger the callback passed to the send() function for
        // a given message.
        triggerCallback: function(data) {
            var dataObj = JSON.parse(data);
            this.dispatcher.triggerCallback(dataObj.messageId, dataObj.data);
        },

        createEnvelope: function(id, type, payload) {
            return {
                id: id,
                type: type,
                host: host,
                payload: payload
            };
        }
    };

    // i.e., use in env that not has jockey native
    var nullDispatcher = {
        send: function(envelope, complete) {
            complete();
        },
        triggerCallback: function() {},
        sendCallback: function() {}
    };

    if (hasJockeyNativeEnv) {
        Jockey.dispatcher = Dispatcher;
    } else {
        Jockey.on = function(type, fn) { fn && fn({noJockey: true}, function(){}) };
        Jockey.send = function(type, payload, complete) {
            complete = (payload instanceof Function) ? payload : (complete || function () {});
            complete({noJockey: true})
        };

        Jockey.dispatcher = nullDispatcher;
    }

    window.Jockey = Jockey;

    var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    //如果是Android，需要send一个指令以让Android知道本页面已经植入jockey
    if (isAndroid) {
        Jockey.send('JockeyExistBridge', {hasJockey: true});
    }
    if (typeof exports === 'object') {
        module.exports = window.Jockey;
    }
})();



//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/jockey/jockey.js
// module id = 46
// module chunks = 4